import React, { PureComponent } from "react";
import { connect } from "react-redux";
//import { components as selectComponents } from "react-select";
import AsyncSelect from "react-select/async";
import axios from "axios";
import debounce from "lodash/debounce";
import { TTP_API_URL } from "Config";

import { selectStyle } from "./ReactSelectStyle";

import _ from "i18n";

export class SearchSelect extends PureComponent {
  selectOption = client => {
    const { onClientSelected } = this.props;
    if (!client || client.length === 0) {
      onClientSelected(null);
      return;
    }

    onClientSelected(client);
  };

  fetchFolders = debounce((inputValue, callback) => {
    const { auth } = this.props;
    if (!auth) {
      callback([]);
    }

    const { token, navCommunity } = auth;

    if (!navCommunity) {
      callback([]);
    }

    const filter = [
      {
        property: "name",
        value: inputValue,
        operator: "like"
      },
      {
        property: "owner",
        value: navCommunity.id,
        operator: "eq"
      }
    ];

    const fields = ["id", "name", "abbreviation", "uen", "legalRepresentative"];

    if (this.lastRequestSource) {
      this.lastRequestSource.cancel();
    }

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.lastRequestSource = source;

    axios
      .get(`${TTP_API_URL}/organization/folder`, {
        cancelToken: source.token,
        params: {
          access_token: token,
          applyFolderRoleFilter: true,
          organization_id: navCommunity ? navCommunity.id : null,
          fields: fields.join(","),
          filter: JSON.stringify(filter)
        }
      })
      .then(resp => callback(resp.data.data))
      .catch(() => callback([]));
  }, 200);

  loadOptions = (inputValue, callback) => {
    this.fetchFolders(inputValue, callback);
  };

  render() {
    return (
      <AsyncSelect
        styles={selectStyle()}
        loadOptions={this.loadOptions}
        getOptionLabel={option => option.name}
        getOptionValue={option => option.value}
        onChange={this.selectOption.bind(this)}
        placeholder={_("Search client...")}
        loadingMessage={() => _("Loading...")}
        noOptionsMessage={() => null}
        openMenuOnClick={false}
      />
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchSelect);



// WEBPACK FOOTER //
// ./src/components/Community/WorkPlace/Search/SearchSelect/index.js